<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="scoringConfiguration?.id
      ? 'league.scoring.group.config.edit'
      : 'league.scoring.group.config.add'"
            [saveDisabled]="inputForm.invalid || disableEditing"
            (onSave)="onSaveButtonClick()"
            (onClose)="onClose()"
    >
      <div class="pb-4">
        <form [formGroup]="inputForm">

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input formControlName="name" label="app.common.name" />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-select
                            formControlName="scoringDefinition"
                            [items]="scoringDefinitions"
                            [labelKey]="'name'"
                            [valueKey]="'id'"
                            label="league.scoring.definition"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-date-time-input formControlName="registrationDeadline" [displayTime]="true"
                                         [label]="t('league.scoring.registrationDeadline')"/>
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-date-time-input formControlName="raceChangeDeadline" [displayTime]="true"
                                         [label]="t('league.scoring.raceChangeDeadline')"/>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-select
                            formControlName="groupScoringType"
                            [items]="groupScoringTypes"
                            [valueKey]="'id'"
                            labelKey="id"
                            labelKeyPrefix="league.scoring.groupScoringType."
                            label="league.scoring.groupScoringType"
                    />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-input
                            type="number"
                            formControlName="maxScoringRounds"
                            label="league.scoring.maxScoringRounds"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input
                            type="number"
                            formControlName="maxTeamMembers"
                            label="league.scoring.maxTeamMembers"
                    />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                        <app-input
                                type="number"
                                formControlName="minTeamFinishers"
                                label="league.scoring.minTeamFinishers"
                        />
                </div>
            </div>

            <div class="row">
                <div class="col-12 pb-3 pt-4">
                    <app-checkbox formControlName="genderSplitMaxMembers" label="league.scoring.genderSplitMaxMembers"/>
                </div>
            </div>

            @if (inputForm.controls.genderSplitMaxMembers.value) {
            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input
                         type="number"
                         formControlName="maxMaleScoringMembers"
                         label="league.scoring.maxMaleScoringMembers"
                        />
                    </div>
                  <div class="col-12 col-xl-6 pb-3">
                 <app-input
                         type="number"
                         formControlName="maxFemaleScoringMembers"
                         label="league.scoring.maxFemaleScoringMembers"
                    />
                </div>
            </div>
            }
            @else {
            <div class="row">
             <div class="col-12 pb-3">
                 <app-input
                         type="number"
                         formControlName="maxScoringMembers"
                         label="league.scoring.maxScoringMembers"
                 />
             </div>
             </div>
            }

            <div class="row">
                <div class="col-12 pt-4">
                    <app-checkbox formControlName="genderSplitMinMembers" label="league.scoring.genderSplitMinMembers"/>
                </div>
            </div>

            @if (inputForm.controls.genderSplitMinMembers.value) {
            <div class="row pt-3">
               <div class="col-12 col-xl-6 pb-3">
                   <app-input
                           type="number"
                           formControlName="minMaleFinishers"
                           label="league.scoring.minMaleFinishers"
                   />
               </div>
               <div class="col-12 col-xl-6 pb-3">
                   <app-input
                           type="number"
                           formControlName="minFemaleFinishers"
                           label="league.scoring.minFemaleFinishers"
                   />
               </div>
           </div>
            }

            <div class="row pt-4">
                <div class="col-12 pb-3">
                    <app-input
                            type="number"
                            formControlName="finishedBonusPoints"
                            label="league.scoring.finishedBonusPoints"
                    />
                </div>
            </div>
        </form>
      </div>
    </app-admin-modal-layout>
</ng-container>
